import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {Logger} from './app/classes/util/logger';

platformBrowserDynamic().bootstrapModule(AppModule).then()
  .catch(err => Logger.logError(err));
